import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import DateFormat from '../../types/enums/DateFormat'

type ProjectDistributionDateRangeState = {
  from: string
  to: string
}

const fromDate = dayjs()
const toDate = dayjs().add(1, 'month')

const initialState: ProjectDistributionDateRangeState = {
  from: fromDate.format(DateFormat.YearMonth),
  to: toDate.format(DateFormat.YearMonth),
}

export const projectDistributionDateRangeSlice = createSlice({
  name: 'projectDistributionDateRange',
  initialState,
  reducers: {
    setFromDate: (state, action: PayloadAction<string>) => {
      state.from = action.payload
    },
    setToDate: (state, action: PayloadAction<string>) => {
      state.to = action.payload
    },
  },
})

export const ProjectDistributionDateRangeActions = projectDistributionDateRangeSlice.actions
export const ProjectDistributionDateRangeReducer = projectDistributionDateRangeSlice.reducer
